import { combineReducers } from 'redux'

import breakpoints from '../../lib/constants/breakpoints.json'

import {
	TOGGLE_MENU,
	RESIZE_SCREEN,
	TYPE_LOADED,
	UPDATE_HEADER_COLOUR,
	TOGGLE_PAGE_IS_TRANSITIONING
} from '../actions'

const headerHeightForWidth = (width) => {
	return width <= breakpoints.mobile ? 60 : 70
}

const hasHamburgerForWidth = (width) => {
	return width <= breakpoints.tabletPortrait ? true : false
}

const screenSizeDefault = {
	width: 1280,
	height: 720
}

const defaultHeaderHeight = headerHeightForWidth(screenSizeDefault.width)
const defaultHasHamburger = hasHamburgerForWidth(screenSizeDefault.width)

const menuOpen = (state = false, action) => {
	switch(action.type){
		case TOGGLE_MENU:
			return action.menu
		default:
			return state
	}
}

const screenSize = (state = screenSizeDefault, action) => {
	switch(action.type){
		case RESIZE_SCREEN:
			return action.screenSize
		default:
			return state
	}
}

const hasHamburger = (state = defaultHasHamburger, action) => {
	switch(action.type){
		case RESIZE_SCREEN:
			return hasHamburgerForWidth(action.screenSize.width)
		default:
			return state
	}
}

const headerHeight = (state = defaultHeaderHeight, action) => {
	switch(action.type){
		case RESIZE_SCREEN:
			return headerHeightForWidth(action.screenSize.width)
		default:
			return state
	}
}

const headerColour = (state = null, action) => {
	switch(action.type){
		case UPDATE_HEADER_COLOUR:
			return action.colour
		default:
			return state
	}
}

const hasTouch = (state = (typeof document !== 'undefined' && 'ontouchstart' in document.documentElement)) => {
	return state
}

const typeLoaded = (state = false, action) => {
	switch(action.type){
		case TYPE_LOADED:
			return action.isLoaded
		default:
			return state
	}
}

const pageIsTransitioning = (state = false, action) => {
	switch(action.type){
		case TOGGLE_PAGE_IS_TRANSITIONING:
			return action.isTransitioning
		default:
			return state
	}
}

export default combineReducers({
	hasHamburger,
	hasTouch,
	headerColour,
	headerHeight,
	menuOpen,
	screenSize,
	typeLoaded,
	pageIsTransitioning
})